import {makeStyles} from "@material-ui/styles";
import {Theme} from "@material-ui/core/styles";

export const seatMapStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  mapCard: {
    background: '#fff',
    borderRadius: 8,
    padding: theme.spacing(3),
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    marginBottom: theme.spacing(2),
  },
  flightInfo: {
    display: 'flex',
    gap: theme.spacing(4),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap' as const,
  },
  flightInfoItem: {
    '& label': {
      display: 'block',
      fontSize: 11,
      color: '#999',
      textTransform: 'uppercase' as const,
      letterSpacing: 0.5,
      marginBottom: 2,
    },
    '& span': {
      display: 'block',
      fontSize: 15,
      fontWeight: 500,
      color: '#333',
    }
  },
  seatMapContainer: {
    overflowX: 'auto' as const,
    padding: theme.spacing(2),
    background: '#fafafa',
    borderRadius: 8,
  },
  columnHeaders: {
    display: 'grid',
    gap: 4,
    marginBottom: 6,
  },
  rowContainer: {
    display: 'grid',
    gap: 4,
    marginBottom: 3,
  },
  rowLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 500,
    color: '#888',
  },
  colLabel: {
    textAlign: 'center' as const,
    fontWeight: 600,
    fontSize: 13,
    color: '#555',
  },
  seat: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
    fontSize: 11,
    fontWeight: 600,
    cursor: 'pointer',
    border: '2px solid transparent',
    transition: 'all 0.15s ease',
    '&:hover': {
      transform: 'scale(1.08)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    },
  },
  seatAvailable: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    borderColor: '#a5d6a7',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#c8e6c9',
    },
  },
  seatBooked: {
    backgroundColor: '#ffebee',
    color: '#c62828',
    borderColor: '#ef9a9a',
    cursor: 'not-allowed',
    '&:hover': {
      transform: 'none',
      boxShadow: 'none',
    },
  },
  seatBlocked: {
    backgroundColor: '#eeeeee',
    color: '#9e9e9e',
    borderColor: '#e0e0e0',
    cursor: 'not-allowed',
    '&:hover': {
      transform: 'none',
      boxShadow: 'none',
    },
  },
  seatSelected: {
    backgroundColor: '#1565c0',
    color: '#fff',
    borderColor: '#0d47a1',
    '&:hover': {
      backgroundColor: '#1976d2',
    },
  },
  legendContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    padding: theme.spacing(2, 0),
    flexWrap: 'wrap' as const,
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: 13,
    color: '#555',
  },
  legendSwatch: {
    width: 18,
    height: 18,
    borderRadius: 4,
    border: '2px solid transparent',
  },
  selectedInfo: {
    background: '#e3f2fd',
    borderRadius: 8,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  selectedSeatChip: {
    margin: theme.spacing(0.5),
  },
}));
